import { useIntl } from 'react-intl'
import { FieldsConfiguration } from '../Field/Field.types'

const getLoginFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()

  return {
    email: {
      id: 'email',
      type: 'email',
      name: 'email',
      placeholder: '',
      label: formatMessage({
        defaultMessage: 'Email address',
        id: 'msp.login_form.label.email'
      }),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your email address.',
          id: 'msp.login_form.error.required_email'
        })
      }
    },
    password: {
      id: 'password',
      type: 'password',
      name: 'password',
      placeholder: '',
      label: formatMessage({
        defaultMessage: 'Password',
        id: 'msp.login_form.label.password'
      }),
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your password.',
          id: 'msp.login_form.error.required_password'
        })
      }
    }
  }
}

export default getLoginFields
